import React from 'react';
import { Card, CardContent, Typography, Button, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
    AddCircleOutline as AddIcon,
    ShoppingCart as OrderIcon,
    PersonAdd as UserIcon,
    Storage as StorageIcon
} from '@mui/icons-material';

const QuickActions: React.FC = () => {
    const navigate = useNavigate();

    const actions = [
        { label: 'New Product', icon: <AddIcon />, path: '/products/new', color: 'primary' },
        { label: 'View Orders', icon: <OrderIcon />, path: '/orders', color: 'info' },
        { label: 'Add User', icon: <UserIcon />, path: '/users', color: 'success' },
        { label: 'System Health', icon: <StorageIcon />, path: '/system/database', color: 'warning' },
    ];

    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontSize: '1rem', fontWeight: 600 }}>
                    Quick Actions
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 2 }}>
                    {actions.map((action) => (
                        <Button
                            key={action.label}
                            variant="outlined"
                            color={action.color as any}
                            startIcon={action.icon}
                            onClick={() => navigate(action.path)}
                            size="small"
                            sx={{
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 500,
                                mb: 1 // Gutter for wrap
                            }}
                        >
                            {action.label}
                        </Button>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default QuickActions;
